/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CarrierType = {
    Individual: 'INDIVIDUAL',
    Business: 'BUSINESS'
} as const;
export type CarrierType = typeof CarrierType[keyof typeof CarrierType];

